export const createGenericOptions = (labels: string[]) => {
  return labels.map((label, index) => ({
    value: index,
    label: label,
    description: getDescriptionForMaturityLevel(index)
  }));
};

/**
 * Returns a generic description for each maturity level to help users understand the scale
 */
const getDescriptionForMaturityLevel = (level: number): string => {
  switch (level) {
    case 0:
      return "Beginning stage with minimal or no formal implementation.";
    case 1:
      return "Early development with basic implementation and limited scope.";
    case 2:
      return "Growing capability with structured processes but not yet enterprise-wide.";
    case 3:
      return "Established practices with consistent implementation across most areas.";
    case 4:
      return "Advanced implementation with comprehensive coverage and optimization.";
    case 5:
      return "Industry-leading capability with innovative approaches and full integration.";
    default:
      return "";
  }
};
